import gql from "graphql-tag";
import { QueryHookOptions, useQuery } from "@apollo/client";

import { ActivityFragment, ACTIVITY_FRAGMENT } from "../../fragments";
import { ActivitiesQueryVariables } from "../../types";

export const GET_ACTIVITIES = gql`
  query getActivities(
    $page: Int
    $per: Int
    $direction: String
    $sortBy: String
  ) {
    activities(per: $per, page: $page, direction: $direction, sortBy: $sortBy) {
      collection {
        ...ActivityFragment
      }
    }
  }
  ${ACTIVITY_FRAGMENT}
`;

export type ActivitiesData = { activities: { collection: ActivityFragment[] } };

export default (
  options?: QueryHookOptions<ActivitiesData, ActivitiesQueryVariables>
) => {
  return useQuery<ActivitiesData, ActivitiesQueryVariables>(
    GET_ACTIVITIES,
    options
  );
};
